export default {
	upload: ['post','common/upload'], // 上传文件
	getFooter: ['get','common/getProjectConfig'], // 获取系统配置(首页底部)
	sendCode: ['get','common/sms'], // 获取手机验证码
	checkCode: ['post','common/verifySmsCode'], // 验证手机验证码
	login: ['post','auth/login'], // 登录
	regit: ['post','auth/register'], // 注册
	unlogin: ['post','user/logout'], // 退出登录
	resetPass: ['post','auth/resetPwdByMobile'], // 重置密码
	getUserInfo: ['post','user/index'], // 获取用户信息
	editUserInfo: ['post','user/profile'], // 修改用户信息
	editUserSpa: ['post','user/bindSpaCode'], // 绑定用户spa
	editUserPhone: ['post','user/changemobile'], // 修改用户手机号
	editUserPass: ['post','auth/resetPwdByMobile'], // 修改用户密码
	getUserCollectList: ['get','user/getGoodscollection'], // 获取用户收藏列表
	getUserAddress: ['get','address/getUserAddressList'], // 获取用户地址列表
	getArticle: ['get','common/getSystemArticle'], // 获取文章(用户协议/隐私政策/关于中智/云智饮片公司/云智饮片优势)
	getIndexBanner: ['get','banner/list'], // 获取首页轮播图
	getShopFilter: ['get','goods/goodsScreen'], // 获取商品列表条件筛选
	getShopList: ['get','goods/goodsList'], // 获取商品列表
	getShopDetail: ['post','goods/goodsDetails'], // 获取商品详情
	getShopDetailAttrNone: ['post','goods/selectUnGoodsSpec'], // 获取商品规格错误时的默认选项
	collectShop: ['post','goods/setGoodsCollection'], // 商品收藏 
	addShopcar: ['post','cart/add'], // 加入购物车
	getShopcar: ['get','cart/getlists'], // 获取购物车列表
	addShopcarNum: ['post','cart/increase'], // 购物车增加数量
	subShopcarNum: ['post','cart/sub'], // 购物车减少数量
	updateShopcarNum: ['post','cart/update_num'], // 购物车更新数量
	deleteShopcar: ['post','cart/delete'], // 批量删除购物车商品
	payment: ['post','order/cartPay'], // 购物车下单
	getUserOrder: ['post','order/orderList'], // 获取用户订单列表
	getUserOrderDetail: ['post','order/orderInfo'], // 获取用户订单详情
	cancelUserOrder: ['post','order/cancel'], // 取消用户订单
	editUserOrder: ['post','order/updateOrderInfo'], // 修改用户订单
	getProductFilter: ['get','product/productScreen'], // 获取产品中心产品分类
	getProductList: ['post','product/productList'], // 获取产品中心列表
	getProductDetail: ['post','product/productDetails'], // 获取产品中心详情
	getStudyNew: ['get','news/getLatestNewList'], // 获取新发布的学术推广列表
	getStudyList: ['get','news/list'], // 获取学术推广列表
	getStudyDetail: ['get','news/info'], // 获取学术推广详情
	getNoticeNoread: ['get','message/getNoReadCount'], // 获取消息中心未读条数
	getNoticeList: ['get','message/list'], // 获取消息中心列表
	getNoticeDetail: ['get','message/info'], // 获取消息中心详情
}


// WEBPACK FOOTER //
// ./src/api/api.js